import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '../ui';
import Header from '../resale/seller/components/header'
import TicketForm from '../ticket-form/form';
import BackContainer from '../resale/seller/components/backContainer'

export default function ModerationUpdateTicketForm({ config, onSubmit }) {
    const { t } = useTranslation();

    const menu = config['moderation-ticket-update-form'];
    const { header, fields, errors, widget_transition_id } = menu;

    const { id: attendeeId } = header;
    const onBackSubmit = () => {
        return onSubmit({
                data: {
                    action: 'previous',
                }
            }
        )}

    const _onSubmit = (data) => {
        console.log(data)
        data["data"]["widget_transition_id"] = widget_transition_id
        return onSubmit(data)
    }
    return (
        <Box className="wz-order-menu">
            <div className='wz-neo-ticket-menu-back'>
                <BackContainer title={t('widget.ticketForm.title')} onClick={onBackSubmit}/>
            </div>
            <Header data={header}/>
            <TicketForm fields={fields} attendeeId={attendeeId} onSubmit={_onSubmit} formErrorsBackend={errors} />
        </Box>
    )
}
